// rw_token cookie management. Set on .redwoodoperations.com so all subdomains
// (dash, sms, wiki, …) can read it via document.cookie. The value is a Cognito
// ID token (real JWT). When it expires, Amplify silently refreshes and the SPA
// re-writes this cookie via the Hub listener in auth.ts.

const COOKIE_NAME = 'rw_token';
const COOKIE_DOMAIN = '.redwoodoperations.com';
// Match the Cognito ID token's 1-hour expiry. Refresh tokens (handled by Amplify)
// extend sessions silently for up to 30 days.
const MAX_AGE_SECONDS = 3600;

export function setIdTokenCookie(idToken: string): void {
  const attrs = [
    `${COOKIE_NAME}=${idToken}`,
    `Domain=${COOKIE_DOMAIN}`,
    `Path=/`,
    `Max-Age=${MAX_AGE_SECONDS}`,
    `Secure`,
    `SameSite=Lax`,
  ];
  document.cookie = attrs.join('; ');
}

export function clearIdTokenCookie(): void {
  document.cookie = `${COOKIE_NAME}=; Domain=${COOKIE_DOMAIN}; Path=/; Max-Age=0; Secure; SameSite=Lax`;
}

export function getIdTokenCookie(): string | null {
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${COOKIE_NAME}=([^;]+)`));
  return match ? decodeURIComponent(match[1]) : null;
}
